var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfButton',{staticClass:"sf-button--pure a-mobile-menu-icon",on:{"click":_vm.goToMenu}},[_c('img',{attrs:{"src":"/assets/custom/icons/icon-menu.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }